import { Component, forwardRef } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../../utils/pagination";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../../actions/fillCombo_action";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../common_components/exhibitor_module_topmenu";
import { getHallViewAuditTrackerList_action } from "../../../../actions/admin_module_action/preSetupTracker_action/hallView_action";
import {
  getLayoutViewAuditTrackerList_action,
  getZoneData_action,
} from "../../../../actions/admin_module_action/preSetupTracker_action/layoutView_action";
import {
  exhibitionId,
  hallActionId,
  HallZoneActionId,
  serviceTypeId,
  stallActionId,
  toastError,
  toastSuccess,
} from "../../../../utils/constants";
import Select from "react-select";
import Modal from "react-modal";
import moment from "moment";
import SvgCanvas from "./SvgCanvas";
// import 'bootstrap-icons/font/bootstrap-icons.css';

const styles = {
  width: "100%",
};

class LayoutView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      StatusID: "",
      hallId: "",
      hallList: [],
      zoneId: "",
      zoneList: [],
      serviceId: "",
      serviceList: [],
      ExhRegNo: "",
      ExhibitorName: "",
      VendorName: "",
      ListIndex: null,
      StatusList: [],
      RoleID: sessionStorage.getItem("RoleIDSS"),
      halls: [],
      grid: [],
      // Raw rows from getHallViewAuditTrackerList - the source of the status counts
      trackerRows: [],
      // Layout SVG related states
      layouts: [],
      selectedLayoutId: null,
      layoutError: null,
      isLayoutLoading: true,
      isGridLoading: true,
      // Hall & Booth filter states for auto-zoom
      filterHallId: "",
      filterBoothId: "",
      // Halls/booths parsed out of the layout SVG
      svgHalls: [],
      svgBooths: [],
      // Zone data for the selected hall (data = zones, data2 = stalls per zone)
      zoneData: [],
      zoneStalls: [],
      selectedZoneId: "",
      isZoneLoading: false,
      zoneError: null,
    };

    this.getVendorAuditTrackerList = this.getVendorAuditTrackerList.bind(this);
    this.renderWorkUpdationList = this.renderWorkUpdationList.bind(this);
    this.loadLayouts = this.loadLayouts.bind(this);
  }

  componentDidMount() {
    this.getFillList(hallActionId, this.state.exhibitionID, "", "", "", "");
    this.getFillList(serviceTypeId, this.state.exhibitionID, "", "", "", "");
    this.getVendorAuditTrackerList();
    this.loadLayouts();
  }

  loadLayouts() {
    const exhibitionId = sessionStorage.getItem('sessionExhibitionID');

    if (!exhibitionId) {
      this.setState({ layoutError: "Exhibition ID not found", isLayoutLoading: false });
      return;
    }

    this.setState({ isLayoutLoading: true, layoutError: null });
    this.props
      .getLayoutViewAuditTrackerList_action(exhibitionId)
      .then((res) => {
        if (res && res.data && res.error === 0) {
          const layouts = res.data.map(layout => {
            // Derive halls from booths if halls array is empty/missing
            if ((!layout.halls || layout.halls.length === 0) && layout.booths && layout.booths.length > 0) {
              const hallMap = {};
              layout.booths.forEach(booth => {
                const hId = booth.HallId || booth.HallID;
                const hName = booth.HallName;
                if (hId && hName && !hallMap[hId]) {
                  hallMap[hId] = { HallID: hId, HallName: hName };
                }
              });
              layout.halls = Object.values(hallMap);
            }
            return layout;
          });
          this.setState({
            layouts,
            isLayoutLoading: false,
            selectedLayoutId: layouts.length > 0 ? layouts[0].MstHallLayoutID : null,
            layoutError: null,
          });
        } else {
          this.setState({
            isLayoutLoading: false,
            layoutError: res?.msg || "Failed to load layouts",
          });
        }
      })
      .catch((err) => {
        console.error("Error loading layouts:", err);
        this.setState({
          isLayoutLoading: false,
          layoutError: "Error loading layouts",
        });
      });
  }

  handleLayoutSelect = (layoutId) => {
    this.setState({
      selectedLayoutId: layoutId,
      filterHallId: "",
      filterBoothId: "",
      zoneData: [],
      zoneStalls: [],
      selectedZoneId: "",
      zoneError: null,
      isZoneLoading: false,
    });
  };

  // The hall dropdown carries SVG-derived ids ("H1", "H3") because the drawing
  // is the source of truth for what can be selected. The zone API needs the
  // database HallId, so resolve across on hall name — the one field both sides
  // agree on. Prefer the master hall list; fall back to the layout payload.
  resolveDbHallId = (svgHallId) => {
    const { svgHalls, hallList, layouts, selectedLayoutId } = this.state;
    const hall = svgHalls.find((h) => h.HallID === svgHallId);
    if (!hall) return null;

    const key = String(hall.HallName || "").trim().toLowerCase();
    const match = (hallList || []).find(
      (h) => String(h.HallName || "").trim().toLowerCase() === key
    );
    if (match) return match.HallId != null ? match.HallId : match.HallID;

    const layout = (layouts || []).find((l) => l.MstHallLayoutID === selectedLayoutId);
    const apiHall = (layout && layout.halls ? layout.halls : []).find(
      (h) => String(h.HallName || "").trim().toLowerCase() === key
    );
    return apiHall ? (apiHall.HallID != null ? apiHall.HallID : apiHall.HallId) : null;
  };

  handleFilterHallChange = (hallId) => {
    this.setState({ filterHallId: hallId, filterBoothId: "" }, () => {
      this.getZoneData(hallId);
    });
  };

  handleZoneChange = (zoneId) => {
    this.setState({ selectedZoneId: zoneId, filterBoothId: "" });
  };

  // getVendorAuditTrackerList already forwards serviceId to the API, so
  // filtering server-side keeps the grid, the legend counts and the popup's
  // service list consistent instead of each filtering its own copy.
  handleServiceChange = (serviceId) => {
    this.setState({ serviceId }, () => this.getVendorAuditTrackerList());
  };

  getZoneData(svgHallId) {
    if (!svgHallId) {
      this.setState({ zoneData: [], zoneStalls: [], selectedZoneId: "", zoneError: null, isZoneLoading: false });
      return;
    }

    const dbHallId = this.resolveDbHallId(svgHallId);
    if (dbHallId == null) {
      const hall = this.state.svgHalls.find((h) => h.HallID === svgHallId);
      this.setState({
        zoneData: [],
        zoneStalls: [],
        selectedZoneId: "",
        isZoneLoading: false,
        zoneError: `"${hall ? hall.HallName : svgHallId}" is in the layout drawing but has no matching hall record, so zones could not be loaded.`,
      });
      return;
    }

    this.setState({ isZoneLoading: true, zoneError: null });
    this.props
      .getZoneData_action(dbHallId)
      .then((res) => {
        // Ignore a response for a hall the user has already moved away from.
        if (this.state.filterHallId !== svgHallId) return;
        if (res && res.error === 0) {
          // data  = zones for the hall, data2 = the stalls inside each zone
          this.setState({
            zoneData: res.data || [],
            zoneStalls: res.data2 || [],
            selectedZoneId: "",
            isZoneLoading: false,
          });
        } else {
          this.setState({
            zoneData: [],
            zoneStalls: [],
            selectedZoneId: "",
            isZoneLoading: false,
            zoneError: (res && res.msg) || "Failed to load zone data.",
          });
        }
      })
      .catch((err) => {
        console.error("Error loading zone data:", err);
        if (this.state.filterHallId !== svgHallId) return;
        this.setState({ zoneData: [], zoneStalls: [], selectedZoneId: "", isZoneLoading: false, zoneError: "Error loading zone data." });
      });
  }

  handleFilterBoothChange = (boothId) => {
    this.setState({ filterBoothId: boothId });
  };

  // Halls/booths as read out of the layout drawing. The API's booths[] carries
  // sequential placeholder ClipIds that do not correspond to this SVG, so the
  // drawing is the source of truth for what can actually be selected.
  handleSvgDataExtracted = ({ halls, booths }) => {
    this.setState({ svgHalls: halls || [], svgBooths: booths || [] });
  };

  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from, flag) {
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data && data.error != 1) {
          if (actionID === hallActionId) {
            this.setState({ hallList: data.data });
          }

          if (actionID === HallZoneActionId) {
            this.setState({ zoneList: data.data });
          }

          if (actionID === serviceTypeId) {
            this.setState({ serviceList: data.data });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  async getVendorAuditTrackerList() {
    const {
      zoneId,
      ExhibitorName,
      VendorName,
      StatusID,
      hallId,
      ExhRegNo,
      serviceId,
    } = this.state;

    this.setState({ isGridLoading: true });

    try {
      const data = await this.props.getHallViewAuditTrackerList_action(
        hallId,
        "",
        ExhRegNo,
        ExhibitorName,
        VendorName,
        StatusID,
        zoneId,
        serviceId
      );

      // Handle API error
      if (!data || data.error === 1) {
        if (data?.error) toastError(data.error);
        return;
      }

      const sampleData = [];

      await data.data.map((item) => {
        sampleData.push({
          Service: item.ServiceName,
          CompanyName: item.CompanyName,
          VendorName: item.VendorName,
          MobileNo: item.MobileNo,
          EmailID: item.PrimaryEmail,
          HallID: item.HallID,
          HallName: item.HallName,
          HallStatus: item.HallStatus,
          IsServiceAllocated: item.IsServiceAllocated,
        });
      });
      console.log("this.transformData(sampleData)2-->", sampleData);
      console.log(
        "this.transformData(sampleData)-->",
        this.transformData(sampleData)
      );
      const { halls, grid } = this.transformData(sampleData);
      this.setState({ halls, grid, trackerRows: data.data || [] });
    } catch (err) {
      console.error("Error in getVendorAuditTrackerList:", err);
      toastError(
        "Something went wrong while fetching Hall Manager Work Updation list."
      );
    } finally {
      this.setState({ isGridLoading: false, isLoading: false });
    }
  }

  transformData(apiData) {
    const halls = [...new Set(apiData.map((item) => item.HallName))];
    const services = [...new Set(apiData.map((item) => item.Service))];

    const grid = services.map((service) => {
      const row = { service };
      halls.forEach((hall) => {
        const records = apiData.filter(
          (d) => d.Service === service && d.HallName === hall
        );
        row[hall] = records.length > 0 ? records : [];
      });
      return row;
    });

    return { halls, grid };
  }

  handleClear() {
    this.setState(
      {
        AccountID: "",
        StatusID: "",
        hallId: "",
        zoneId: "",
        serviceId: "",
        ExhRegNo: "",
        ExhibitorName: "",
        VendorName: "",
        ExhibitionOtherAreaID: "",
        PossessionStatusID: "",
      },
      () => this.getVendorAuditTrackerList()
    );
  }

  navigateToVendorAndScopofwork(userId, accountId, WorkOrderID) {
    this.props.navigate("/vendorAndScopofwork", {
      state: {
        AccountID: accountId,
        UserId: userId,
        update: true,
        update: true,
        isView: false,
        replicate: false,
        WorkOrderID: WorkOrderID,
        isHallManager: sessionStorage.getItem("RoleIDSS") == 16,
        isWorkUpdation: true,
      },
    });
  }

  renderWorkUpdationList() {
    const { halls, grid } = this.state;

    return (
      <div className="row m-0">
        <div class="table-responsive sticky-table-wrapper border-bottom service-list-grid-1 mx-2 p-0">
          <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0 me-2">
            <thead class="table-light">
              <tr>
                <th
                  className="text-center">
                  Services
                </th>
                {halls.map((hall, index) => (
                  <th
                    key={index}
                    className="text-center">
                    {hall}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {grid.map((row, i) => (
                <tr key={i}>
                  {/* Service column with icons */}
                  <td className="text-center align-middle fw-semibold">
                    {row.service}
                  </td>

                  {/* Hall data cells */}
                  {halls.map((hall, j) => {
                    const vendors = row[hall];
                    return (
                      <td
                        key={j}
                        className={
                          (vendors && vendors.length > 0)
                            ? "p-2 align-top"
                            : "text-center align-middle fst-italic text-muted"
                        }
                      >
                        {(!vendors || vendors.length === 0) && (
                          'Not Allocated'
                        )}
                        {vendors &&
                          vendors.map((v, k) => (
                            <div
                              key={k}
                              // className="mb-3 pb-2 border-bottom border-gray-200 last:border-0"
                              className="mb-3 pb-2"
                            >
                              <div>
                                <i className="ri-building-4-line me-1 grid-icon "></i>{" "}
                                {v.CompanyName}
                              </div>
                              <div>
                                <i className="ri-user-3-line grid-icon"></i>{" "}
                                {v.VendorName}
                              </div>
                              <div>
                                <i className="ri-phone-line grid-icon"></i>{" "}
                                {v.MobileNo}
                              </div>
                              <div>
                                <i className="ri-mail-line grid-icon"></i>{" "}
                                {v.EmailID}
                              </div>
                              <div>
                                <span className={`badge bg-aqua text-white fw-normal ${v.HallStatus == 'Completed' ? 'completed' : v.HallStatus == 'Pending' ? 'pending' : v.HallStatus == 'InProgress' ? 'inprogress' : 'delayed'}`}>
                                  {v.HallStatus == 'Completed' ? 'Completed' : v.HallStatus == 'Pending' ? 'Pending' : v.HallStatus == 'inprogress' ? 'inprogress' : 'In Progress'}
                                </span>
                              </div>
                            </div>
                          ))}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  render() {
    const {
      isLoading,
      isGridLoading,
      isUpdateModalOpen,
      hallId,
      hallList,
      zoneId,
      zoneList,
      serviceId,
      serviceList,
      ExhibitorName,
      ExhRegNo,
      VendorName,
      RoleID,
      layouts,
      selectedLayoutId,
      layoutError,
      isLayoutLoading,
      filterHallId,
      filterBoothId,
      grid,
      trackerRows,
      svgHalls,
      zoneData,
      zoneStalls,
      selectedZoneId,
      isZoneLoading,
      zoneError,
    } = this.state;

    const selectedLayout = layouts.find(l => l.MstHallLayoutID === selectedLayoutId);

    // Legend counts come from the work-updation tracker, so they reflect the
    // real HallStatus records rather than anything derived in the UI.
    const statusCounts = trackerRows.reduce((acc, row) => {
      const key = String(row.HallStatus || "").trim() || "Unallocated";
      acc[key] = (acc[key] || 0) + 1;
      return acc;
    }, {});

    return (
      <>
        <ToastContainer />
        {RoleID == 16 && <HeaderWithLogo />}
        {/* <ExhibitorDrawer /> */}
        <>
          {/* <AdminDrawer /> */}
          {/*app-content open*/}
          <div
            className="app-content with-dr-container com-height admin-top-space"
            style={{ marginLeft: 0 }}
          >
            <main id="main" className={RoleID == 16 ? "px-3" : "px-1"}>
              <section className="section" style={{ padding: 0 }}>
                {/* Layout SVG Display Section */}
                {layoutError && (
                  <div className="alert alert-info alert-dismissible fade show mb-4" role="alert">
                    <i className="ri-information-line me-2"></i>
                    {layoutError}
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => this.setState({ layoutError: null })}
                    ></button>
                  </div>
                )}

                {/* ─── Static Container for Hall Layout View ─── */}
                <div className="layout-view-container mb-5 p-4 bg-light rounded shadow-sm">
                  <h5 className="mb-3 fw-bold text-dark">
                    <i className="ri-layout-3-line me-2 text-primary"></i>Hall Layout View
                  </h5>

                  {isLayoutLoading ? (
                    <div className="bg-white p-5 rounded border text-center my-2">
                      <div className="spinner-border text-primary mb-3" style={{ width: "2.5rem", height: "2.5rem" }} role="status">
                        <span className="visually-hidden">Loading layout...</span>
                      </div>
                      <h6 className="fw-semibold text-dark mb-1">Loading Hall Layout Map...</h6>
                      <small className="text-muted d-block mb-3">Please wait while interactive layout SVG and booth allocations load.</small>

                      {/* Skeleton placeholders for mapped hall cards */}
                      <div className="mt-4 pt-3 border-top">
                        <small className="text-muted d-block text-start mb-2 fw-semibold">Mapped Halls Skeleton:</small>
                        <div className="row">
                          {[1, 2, 3].map((i) => (
                            <div key={i} className="col-md-6 col-lg-4 mb-3">
                              <div className="card shadow-sm border-0 bg-light p-3 text-start">
                                <div className="placeholder-glow">
                                  <span className="placeholder col-8 bg-secondary mb-2 rounded"></span>
                                  <span className="placeholder col-4 bg-secondary-subtle d-block rounded"></span>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ) : layouts.length > 0 ? (
                    <>
                      {/* Layout Selector */}
                      {layouts.length > 1 && (
                        <div className="mb-4">
                          <label className="form-label fw-semibold">Select Layout:</label>
                          <div className="btn-group d-flex" role="group">
                            {layouts.map((layout) => (
                              <button
                                key={layout.MstHallLayoutID}
                                type="button"
                                className={`btn btn-sm flex-fill ${selectedLayoutId === layout.MstHallLayoutID
                                  ? "btn-primary"
                                  : "btn-outline-primary"
                                  }`}
                                onClick={() => this.handleLayoutSelect(layout.MstHallLayoutID)}
                              >
                                {layout.LayoutName}
                                <span className="badge bg-secondary ms-2">
                                  {layout.halls ? layout.halls.length : layout.MappedHallsCount}
                                </span>
                              </button>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* SVG Canvas */}
                      {selectedLayout && (
                        <div className="layout-canvas-wrapper">
                          <SvgCanvas
                            layout={selectedLayout}
                            filterHallId={filterHallId}
                            filterBoothId={filterBoothId}
                            onFilterHallChange={this.handleFilterHallChange}
                            onFilterBoothChange={this.handleFilterBoothChange}
                            onSvgDataExtracted={this.handleSvgDataExtracted}
                            zones={zoneData}
                            selectedZoneId={selectedZoneId}
                            onZoneChange={this.handleZoneChange}
                            isZoneLoading={isZoneLoading}
                            zoneStalls={zoneStalls}
                            statusCounts={statusCounts}
                            isStatusLoading={isGridLoading}
                            trackerRows={trackerRows}
                            services={serviceList}
                            selectedServiceId={serviceId}
                            onServiceChange={this.handleServiceChange}
                          />

                          {zoneError && (
                            <div className="alert alert-warning d-flex align-items-center py-2 px-3 mt-3 mb-0 small" role="alert">
                              <i className="ri-error-warning-line me-2"></i>
                              {zoneError}
                            </div>
                          )}

                          {/* Halls List - from the drawing, so it matches the dropdown */}
                          {svgHalls.length > 0 && (
                            <div className="mt-4">
                              <h6>
                                <i className="ri-building-4-line me-2"></i>
                                Halls in Layout ({svgHalls.length})
                              </h6>
                              <div className="row">
                                {svgHalls.map((hall) => (
                                  <div key={hall.HallID} className="col-md-6 col-lg-4 mb-3">
                                    <div
                                      className={`card shadow-sm ${filterHallId === hall.HallID ? "border-primary" : ""}`}
                                      role="button"
                                      onClick={() => this.handleFilterHallChange(hall.HallID)}
                                    >
                                      <div className="card-body">
                                        <h6 className="card-title mb-2">
                                          <i className="ri-building-line me-2"></i>
                                          {hall.HallName}
                                        </h6>
                                        <small className="text-secondary d-block">
                                          <i className="ri-store-2-line me-1"></i>
                                          {hall.BoothCount} booths
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="alert alert-secondary mb-0" role="alert">
                      <i className="ri-information-line me-2"></i>No hall layouts available for this exhibition.
                    </div>
                  )}
                </div>

                {/* ─── Static Container for Hall Work Updation Tracker ─── */}
                <div className="work-updation-container mb-5 p-4 bg-white rounded shadow-sm border">
                  <h5 className="mb-3 fw-bold text-dark">
                    <i className="ri-list-check-2 me-2 text-primary"></i>Hall Work Updation Tracker
                  </h5>

                  {isGridLoading ? (
                    <div className="p-4 text-center">
                      <div className="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
                      <span className="text-muted fw-semibold">Loading tracker data & hall services...</span>
                    </div>
                  ) : grid && grid.length > 0 ? (
                    this.renderWorkUpdationList()
                  ) : (
                    <div className="text-muted fst-italic py-3 text-center">
                      <i className="ri-inbox-line me-1"></i>No tracker records available for the selected filters.
                    </div>
                  )}
                </div>
              </section>
            </main>
          </div>
        </>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    getHallViewAuditTrackerList_action,
    getLayoutViewAuditTrackerList_action,
    getZoneData_action,
  })(LayoutView)
);
